export const ASSOCIATIONS_CODES = [
  '7321',
  '7323',
  '9150',
  '9220',
  '9221',
  '9222',
  '9223',
  '9224',
  '9230',
  '9300',
  'AC',
  'DE602',
  'BE017',
] as const;

export const ORGANIZATION_TYPES = {
  FREELANCER: 'freelancer',
  SMALL_BUSINESS: 'small_business',
  COMPANY: 'company',
  BIG_COMPANY: 'big_company',
  ASSOCIATION: 'association',
  WORKS_COUNCIL: 'works_council',
} as const;

export type OrganizationType = (typeof ORGANIZATION_TYPES)[keyof typeof ORGANIZATION_TYPES];

export const GBR_LEGAL_CODE = 'DE101';
export const EGBR_LEGAL_CODE = 'DE111';
export const VEREINE_LEGAL_CODE = 'DE602';
export const EK_LEGAL_CODE = 'DE001';
export const EINZELUNTERNEHMER_LEGAL_CODE = 'DE002';
export const FREIBERUFLER_LEGAL_CODE = 'DE210';

export const AT_EINZELUNTERNEHMER_LEGAL_CODE = 'ATCUST301';

export const ZELFSTANDIGE_LEGAL_CODE = 'BECUST201';
export const BE_VZW_LEGAL_CODE = 'BE017';

export const EENMANSZAAK_LEGAL_CODE = 'NLCUST208';
export const NL_STICHTING_LEGAL_CODE = 'NL206';
export const ENI_LEGAL_CODE = 'PTCUST183';
export const TRABALHADOR_INDEPENDENTE = 'PTCUST184';

export const GERMAN_SOLO_LEGAL_FORMS = [
  EINZELUNTERNEHMER_LEGAL_CODE,
  FREIBERUFLER_LEGAL_CODE,
  EK_LEGAL_CODE,
] as const;

export const UNIPERSONAL_CODES = [
  FREIBERUFLER_LEGAL_CODE,
  EINZELUNTERNEHMER_LEGAL_CODE,
  'IT002',
  'ESC01',
  AT_EINZELUNTERNEHMER_LEGAL_CODE,
  ZELFSTANDIGE_LEGAL_CODE,
  EENMANSZAAK_LEGAL_CODE,
  ENI_LEGAL_CODE,
  TRABALHADOR_INDEPENDENTE,
] as const;

export const NON_POWERABLE_CREDITSAFE_CODES = [
  '5720',
  '5498',
  '1500',
  '1000',
  ...GERMAN_SOLO_LEGAL_FORMS,
] as const;

export const PHYSICAL_PERSON_COMPANY_TYPES = [
  '1000',
  '1100',
  '1200',
  '1300',
  '1500',
  '1600',
  '1700',
  '1900',
  'AC',
  'DI',
  'IF',
  'PF',
  'IT001',
  'IT002',
  'DE001',
  'DE002',
  'DE210',
  'ESC01',
  'ESC02',
] as const;

export const ITALIAN_FOUNDATION_CREDITSAFE_CODES = ['FI', 'FO'] as const;
export const ITALIAN_LIMITED_COMPANY_CREDITSAFE_CODES = ['SP', 'AA', 'SR', 'SU', 'RS'] as const;
export const ITALIAN_PARTNERSHIP_CREDITSAFE_CODES = ['SE', 'SN', 'AS', 'SF', 'SI', 'CE'] as const;
export const ITALIAN_COOPERATION_CREDITSAFE_CODES = [
  'PC',
  'PS',
  'CL',
  'SC',
  'CI',
  'OO',
  'MA',
] as const;

export const PARTG_LEGAL_CODE = 'DE105';
export const PARTGMBB_LEGAL_CODE = 'DE106';

export const NETHERLANDS_AND_BELGIUM_UBO_LEGAL_FORM_CODES = [
  'NL101',
  'NL206',
  'NL071',
  'NL070',
  'NL304',
  'BE610',
  'BE011',
  'BE012',
  'BE014',
  'BE017',
] as const;

export const GBR_MANAGEMENT_TYPES = {
  SINGLE: 'single',
  JOINT: 'joint',
} as const;

export const CIVIL_COMPANY_CODES = ['6599', '6540'] as const;
